import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/app/services/Helper/helper.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { AccountDetailsParameters } from 'src/app/models/ui/AccountDetailsParameters';
import notify from 'devextreme/ui/notify';
import { LookupService } from 'src/app/services/Lookup/lookup.service';

@Component({
  selector: 'app-financial-settings',
  templateUrl: './financial-settings.component.html',
  styleUrls: ['./financial-settings.component.css']
})
export class FinancialSettingsComponent implements OnInit {

  constructor(private helper: HelperService, private registrationService: RegistrationService, private lookup: LookupService) { 
    this.accountDetails = new AccountDetailsParameters();
    this.account = new AccountDetailsParameters();
  }

  isAuthorized: string;

  account: AccountDetailsParameters;
  accountDetails: AccountDetailsParameters;
  
  ngOnInit() {
    this.isAuthorized = localStorage.getItem("isAuthorized");

    this.lookup.getAccount().subscribe(data => this.account = data);

    if(this.isAuthorized === "true") {
      this.helper.setTitle('Provider - Financial Settings');
    }
    else
      location.assign("#/login-form");
  }

  submitChanges(e) {
    this.registrationService.updateAccountDetails(this.accountDetails).subscribe(data=>this.afterUpdate(data));
  }

  afterUpdate(data) {
    alert(data);
    setTimeout(() => {
      location.reload();
    }, 2000);
  }
}